import React, { useEffect, createElement } from 'react';
import { ArrowRightIcon, HomeIcon, SearchIcon, MapPinIcon, BookOpenIcon } from 'lucide-react';
export function NotFoundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Pagina niet gevonden | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Deze pagina bestaat niet. Ga terug naar de homepage van Noord Digital of bekijk onze diensten, sectoren en lokale webdesign pagina's.";
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Pagina niet gevonden | Noord',
      'og:description': 'Deze pagina bestaat niet. Ga terug naar de homepage van Noord Digital.',
      'og:type': 'website',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <main className="pt-16 lg:pt-[72px] min-h-[80vh] flex flex-col" data-id="element-1603">
      <section className="relative flex-grow flex items-center justify-center py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-1604">
        {/* Background decorative elements */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-1605">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-1606" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-1607" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-1608" />
        </div>

        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full" data-id="element-1609">
          <div className="text-8xl md:text-9xl font-extrabold text-accent/20 mb-4 animate-fade-in-up select-none" data-id="element-1610">
            404
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6 animate-fade-in-up-delay-1" data-id="element-1611">
            Pagina niet gevonden
          </h1>
          <p className="text-lg text-navy-200 mb-12 animate-fade-in-up-delay-2" data-id="element-1612">
            De pagina die je zoekt bestaat niet of is verplaatst.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left animate-fade-in-up-delay-3 max-w-2xl mx-auto" data-id="element-1613">
            <a href="#/" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1614">
              <div className="flex items-center gap-3" data-id="element-1615">
                <HomeIcon className="w-5 h-5 text-accent" data-id="element-1616" />
                <span className="font-medium text-white" data-id="element-1617">Homepage</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1618" />
            </a>
            <a href="#/website-laten-maken" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1619">
              <div className="flex items-center gap-3" data-id="element-1620">
                <SearchIcon className="w-5 h-5 text-accent" data-id="element-1621" />
                <span className="font-medium text-white" data-id="element-1622">Diensten</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1623" />
            </a>
            <a href="#/kennisbank" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1624">
              <div className="flex items-center gap-3" data-id="element-1625">
                <BookOpenIcon className="w-5 h-5 text-accent" data-id="element-1626" />
                <span className="font-medium text-white" data-id="element-1627">Kennisbank</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1628" />
            </a>
            <a href="#/alle-locaties" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1629">
              <div className="flex items-center gap-3" data-id="element-1630">
                <MapPinIcon className="w-5 h-5 text-accent" data-id="element-1631" />
                <span className="font-medium text-white" data-id="element-1632">Alle locaties</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1633" />
            </a>
          </div>
        </div>
      </section>
    </main>;
}